import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import './home.css'

const Home = (props) => {
  return (
    <div className="home-container1">
      <Helmet>
        <title>Danny D. Leybzon</title>
        <meta property="og:title" content="Danny D. Leybzon" />
      </Helmet>
      <section className="hero-section">
        <div className="hero-background-layer"></div>
        <div className="hero-wrapper">
          <div className="hero-content">
            <div className="hero-profile-container">
              <div className="hero-profile-ring"></div>
              <img
                src="/images/avatar.jpg"
                alt="Profile headshot"
                className="hero-profile-image"
              />
            </div>
            <h1 className="hero-title">Danny D. Leybzon</h1>
            <p className="hero-bio">
              {' '}
              I lift weights, dance lots, and build{' '}
              <a
                href="https://www.miravoice.com"
                target="_blank"
                rel="noreferrer noopener"
                style={{ color: '#2874DE', textDecoration: 'none' }}
              >
                Miravoice
              </a>
              .
            </p>
          </div>
        </div>
      </section>
      <section className="features-section">
        <div className="features-wrapper">
          <div className="features-bento-grid">
            <a
              href="/linkedin"
              target="_blank"
              rel="noreferrer noopener"
            >
              <div
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn Profile"
                className="features-social-card"
              >
                <div className="features-card-content">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className="features-icon"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2a2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6M2 9h4v12H2z"></path>
                      <circle cx="4" cy="4" r="2"></circle>
                    </g>
                  </svg>
                  <span className="features-card-label">LinkedIn</span>
                </div>
              </div>
            </a>
            <a
              href="/substack"
              target="_blank"
              rel="noreferrer noopener"
            >
              <div
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Substack Newsletter"
                className="features-social-card"
              >
                <div className="features-card-content">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className="features-icon"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="M15 18h-5m8-4h-8m-6 8h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-4 0v-9a2 2 0 0 1 2-2h2"></path>
                      <rect width="8" height="4" x="10" y="6" rx="1"></rect>
                    </g>
                  </svg>
                  <span className="features-card-label">Substack</span>
                </div>
              </div>
            </a>
            <a
              href="/instagram"
              target="_blank"
              rel="noreferrer noopener"
            >
              <div
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram Profile"
                className="features-social-card"
              >
                <div className="features-card-content">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className="features-icon"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <rect
                        width="20"
                        height="20"
                        x="2"
                        y="2"
                        rx="5"
                        ry="5"
                      ></rect>
                      <path d="M16 11.37A4 4 0 1 1 12.63 8A4 4 0 0 1 16 11.37m1.5-4.87h.01"></path>
                    </g>
                  </svg>
                  <span className="features-card-label">Instagram</span>
                </div>
              </div>
            </a>
            <a
              href="/facebook"
              target="_blank"
              rel="noreferrer noopener"
            >
              <div
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook Profile"
                className="features-social-card"
              >
                <div className="features-card-content">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className="features-icon"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
                    ></path>
                  </svg>
                  <span className="features-card-label">Facebook</span>
                </div>
              </div>
            </a>
            <a
              href="/scholar"
              target="_blank"
              rel="noreferrer noopener"
            >
              <div
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Google Scholar Profile"
                className="features-social-card"
              >
                <div className="features-card-content">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className="features-icon"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0zM22 10v6"></path>
                      <path d="M6 12.5V16a6 3 0 0 0 12 0v-3.5"></path>
                    </g>
                  </svg>
                  <span className="features-card-label">Scholar</span>
                </div>
              </div>
            </a>
            <a
              href="/goodreads"
              target="_blank"
              rel="noreferrer noopener"
            >
              <div
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Goodreads Profile"
                className="features-social-card"
              >
                <div className="features-card-content">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className="features-icon"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"
                    ></path>
                  </svg>
                  <span className="features-card-label">Goodreads</span>
                </div>
              </div>
            </a>
            <a
              href="/medium"
              target="_blank"
              rel="noreferrer noopener"
            >
              <div
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Medium Profile"
                className="features-social-card"
              >
                <div className="features-card-content">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className="features-icon"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                      <path d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z"></path>
                    </g>
                  </svg>
                  <span className="features-card-label">Medium</span>
                </div>
              </div>
            </a>
            <a href="mailto:danny.leybzon@gmail.com?subject=">
              <div aria-label="Email Contact" className="features-social-card">
                <div className="features-card-content">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className="features-icon"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                      <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                    </g>
                  </svg>
                  <span className="features-card-label">Email</span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </section>
      <div className="home-container2">
        <div className="home-container3">
          <Script
            html={`<style>
@media (prefers-reduced-motion: reduce) {
.hero-profile-image, .features-social-card, .features-icon, .showcase-image, .showcase-icon {
  transition: none;
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="home-container4">
        <div className="home-container5">
          <Script
            html={`<script defer data-name="parallax-scroll">
(function(){
  const heroSection = document.querySelector(".hero-section")
  const heroContent = document.querySelector(".hero-content")
  const heroBackground = document.querySelector(".hero-background-layer")

  if (heroSection && heroContent && heroBackground) {
    let ticking = false

    window.addEventListener("scroll", () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrolled = window.pageYOffset
          const heroHeight = heroSection.offsetHeight

          if (scrolled < heroHeight) {
            const scrollRatio = scrolled / heroHeight
            heroContent.style.transform = \`translateY(\${scrolled * 0.3}px)\`
            heroContent.style.opacity = 1 - scrollRatio * 0.8
            heroBackground.style.transform = \`translateY(\${scrolled * 0.5}px)\`
          }

          ticking = false
        })

        ticking = true
      }
    })
  }

  const showcaseSection = document.querySelector(".showcase-section")
  const showcaseBackground = document.querySelector(
    ".showcase-background-layer"
  )

  if (showcaseSection && showcaseBackground) {
    let showcaseTicking = false

    window.addEventListener("scroll", () => {
      if (!showcaseTicking) {
        window.requestAnimationFrame(() => {
          const sectionTop = showcaseSection.offsetTop
          const scrolled = window.pageYOffset
          const sectionHeight = showcaseSection.offsetHeight

          if (
            scrolled > sectionTop - window.innerHeight &&
            scrolled < sectionTop + sectionHeight
          ) {
            const relativeScroll = scrolled - (sectionTop - window.innerHeight)
            showcaseBackground.style.transform = \`translateY(\${
              relativeScroll * 0.2
            }px)\`
          }

          showcaseTicking = false
        })

        showcaseTicking = true
      }
    })
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Home
